const controllers = [
  {
    id: 1,
    value: 'user_management',
    label: 'User Management'
  },
  {
    id: 2,
    value: 'franchisee_management',
    label: 'Franchise Management'
  },
  {
    id: 3,
    value: 'file_repository',
    label: 'File Repository'
  },
  {
    id: 4,
    value: 'child_enrolment',
    label: 'Child Enrolment'
  },
  {
    id: 5,
    value: 'operating_manual',
    label: 'Operating Manual'
  },
  {
    id: 6,
    value: 'training_files',
    label: 'Training Files'
  },
  {
    id: 7,
    value: 'form_management',
    label: 'Form Management'
  },
  {
    id: 8,
    value: 'notification_management',
    label: 'Notification Management'
  },
  {
    id: 9,
    value: 'announcements',
    label: 'Announcements'
  },
  {
    id: 10,
    value: 'overview',
    label: 'Overview'
  },
  {
    id: 11,
    value: 'children-enrolled',
    label: 'Children Enroled'
  },

];

const actions = [
  {
    id: 1,
    value: 'listing',
    label: 'Listing'
  },
  {
    id: 2,
    value: 'add',
    label: 'Add'
  },
  {
    id: 3,
    value: 'edit',
    label: 'Edit'
  },
  {
    id: 4,
    value: 'view_detail',
    label: 'View Details'
  },
  {
    id: 5,
    value: 'delete',
    label: 'Delete'
  },
  {
    id: 6,
    value: 'change_status',
    label: 'Change Status'
  },
  {
    id: 7,
    value: 'share',
    label: 'Share'
  },
  {
    id: 8,
    value: 'download',
    label: 'Download'
  },
]

module.exports = { controllers, actions };